import * as React from 'react'
import { Box, Fab, CircularProgress } from '@mui/material'
import { Check, Save } from '@mui/icons-material'
import { green } from '@mui/material/colors'
import { updateSpecieTableById } from '../../../services'

const SpeciesActions = ({ params, rowId, setRowId }) => {
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`

  const handleSubmit = () => {
    setLoading(true)
    const { id, nombre_cientifico, idFamilia, habilitado } = params.row
    const data = { nombre_cientifico, idFamilia, habilitado }
    setTimeout(async () => {
      const result = await updateSpecieTableById(data, TOKEN, id)
      if (result?.update) {
        setSuccess(true)
        setRowId(null)
      }
      setLoading(false)
    }, 1000)
  }

  React.useEffect(() => {
    if (rowId === params.id && success) setSuccess(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId])

  return (
    <Box sx={{ m: 1, position: 'relative' }}>
      {success ? (
        <Fab
          color="primary"
          sx={{
            width: 40,
            height: 40,
            bgcolor: green[500],
            '&:hover': { bgcolor: green[700] },
          }}>
          <Check />
        </Fab>
      ) : (
        <Fab
          color="primary"
          sx={{
            width: 40,
            height: 40,
          }}
          disabled={params.id !== rowId || loading}
          onClick={handleSubmit}>
          <Save />
        </Fab>
      )}
      {loading && (
        <CircularProgress
          size={52}
          sx={{ color: green[500], position: 'absolute', top: -6, left: -6, xIndex: 1 }}
        />
      )}
    </Box>
  )
}

export default SpeciesActions
